/* eslint-disable react/jsx-sort-props,react/jsx-no-bind */
import React, {useCallback, useEffect, useState} from "react";

import {
    authService
} from "../../../../service";
import { IconAccountLogin, IconLogoComrex } from "../../base/icons";
import { ActionButton, InputField } from "../../base/premeeting";
import Footer from "../../base/premeeting/components/web/Footer";
import Preview from "../../base/premeeting/components/web/Preview";
import { useNextInput } from "../useNextInput";
import { translate } from "../../base/i18n";
import { ToastContainer, toast } from 'react-toastify';

const passwordRegx = /^(?=.*?[A-Z|a-z])(?=.*?[0-9])(?=.*?[!@#\$&*~]).{6,}$/
const Invitation = (props) => {
    const { t } = props;
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [acceptedInvitation, setAcceptedInvitation] = useState(true);
    const [mod, setMod] = useState(null)
    const [error, setError] = useState({
        password: "",
        confirmPassword: ""
    });
    const query = new URLSearchParams(window.location.search)
    const token = query.get('token')
    const { registerInput } = useNextInput();

    const { DISPLAY_WELCOME_FOOTER } = interfaceConfig;

    const getContentClassName = () => {
        const showAdditionalContent =
            interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT &&
            this._additionalContentTemplate &&
            this._additionalContentTemplate.content &&
            this._additionalContentTemplate.innerHTML.trim();

        return showAdditionalContent ? "with-content" : "without-content";
    };

    const contentClassName = getContentClassName();
    const footerClassName = DISPLAY_WELCOME_FOOTER
        ? "with-footer"
        : "without-footer";
    const acceptInvitation = async () => {
        try {
            const res = await authService.invitation(token)
            if(res.data.moderator) {
                setAcceptedInvitation(true)
                setMod(res.data.moderator)
            }
        } catch (e) {
            setAcceptedInvitation(false)
        }
    }

    useEffect(() => {
        if(!token) {
            setAcceptedInvitation(false)
            return
        }
        acceptInvitation()
    }, [token])

    const handleSubmit = useCallback(() => {
        if(!mod) return
        if(password === '') {
            setError({
                ...error,
                password: "Password is required"
            });
        } else if(!passwordRegx.test(password)) {
            setError({
                ...error,
                password: "Password MUST contain at least 6 characters and at least one number and special character"
            });
        } else if(password.length > 24) {
            setError({
                ...error,
                password: "Maximum length is 24 characters"
            });
        } else if(confirmPassword !== password) {
            setError({
                ...error,
                confirmPassword: "The passwords do not match"
            });
        } else {

            setError({
                password: "",
                confirmPassword: ""
            });
            authService.setupPassword({ id: mod?.id, password })
                .then(resp => {
                    if(resp.data.success) {
                        toast('Setup password successful!' || 'Errors', {
                            type: "success"
                        })
                        window.location.replace('/')
                    }
                })
                .catch(err => {
                    toast(err?.response?.data?.message || 'Errors', {
                        type: "error"
                    })
                })
        }
    }, [password, confirmPassword, token, mod]);

    return (
        <>
            <div
                className={`welcome ${contentClassName} ${footerClassName}`}
                id="reset_password_page"
            >
                <Preview />

                <div className="content welcome-screen">
                    <div className="content-body content-body-500 content-body-welcome-screen height-100">
                        <div style={{ width: "100%" }}>
                            <div className="flex-row jus-between login-form-500" style={{alignItems: 'center'}}>
                                <div>
                                    <a href='https://www.comrex.com/' target={'_blank'}>
                                        <IconLogoComrex
                                            className={"comrex-icon-500"}
                                            height="40px"
                                        />
                                    </a>
                                </div>
                                <div>
                                    <img
                                        className={"gagl-logo"}
                                        src="./images/gagl.png"
                                    />
                                </div>
                            </div>
                            <div
                                className="prejoin-input-area-container login-form-500"
                                style={{
                                    backgroundColor: "white",
                                    marginTop: 25,
                                    borderRadius: 16,
                                    boxShadow: "1px 1px 2px 1px rgb(0 0 0 / 25%)",
                                }}
                            >
                                <div
                                    className={"login-form-header-100"}
                                    style={{
                                        height: 140,
                                        width: "100%",
                                        backgroundColor: "#9eb7ca",
                                        position: "relative",
                                        borderTopLeftRadius: 10,
                                        borderTopRightRadius: 10,
                                    }}
                                >
                                    <div
                                        style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <img
                                            width="92%"
                                            height="100%"
                                            src="./images/account-background.png"
                                        />
                                    </div>
                                    <div
                                        style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <IconAccountLogin height="100%" />
                                    </div>
                                </div>
                                {
                                    !acceptedInvitation ? (
                                        <div className="prejoin-input-area welcome-input-side padding-350">
                                            <h3 className="text-xl font-bold">Your invitation is no longer available.</h3>
                                            <h5>If your account is not yet active, please contact your Administrator.</h5>
                                        </div>
                                    ) : (
                                        <div className="prejoin-input-area welcome-input-side padding-350">
                                            <div style={{ width: "100%" }}>
                                                <InputField
                                                    ref={registerInput}
                                                    type="password"
                                                    autoFocus={true}
                                                    onChange={(value) => {
                                                        setPassword(value);
                                                        setError({
                                                            ...error,
                                                            password: "",
                                                        });
                                                    }}
                                                    value={password}
                                                    placeHolder={t("resetPassword.new")}
                                                />
                                                <p
                                                    style={{
                                                        color: "red",
                                                        display: "flex",
                                                        textAlign: "left",
                                                        paddingTop: 8
                                                    }}
                                                >
                                                    {error.password}
                                                </p>
                                            </div>
                                            <div style={{ width: "100%", marginTop: 12 }}>
                                                <InputField
                                                    ref={registerInput}
                                                    type="password"
                                                    autoFocus={true}
                                                    onChange={(value) => {
                                                        setConfirmPassword(value);
                                                        setError({
                                                            ...error,
                                                            confirmPassword: "",
                                                        });
                                                    }}
                                                    value={confirmPassword}
                                                    placeHolder={t("resetPassword.confirm")}
                                                />
                                                <p
                                                    style={{
                                                        color: "red",
                                                        display: "flex",
                                                        textAlign: "left",
                                                        paddingTop: 8
                                                    }}
                                                >
                                                    {error.confirmPassword}
                                                </p>
                                            </div>
                                            <div style={{ marginTop: 30 }}>
                                                <ActionButton
                                                    ref={registerInput}
                                                    className="button-login"
                                                    onClick={() => handleSubmit()}
                                                    type="primary"
                                                >
                                                    {t("login.submit")}
                                                </ActionButton>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <div className={"footer-welcome-screen z-index-1"}>
                        <Footer />
                    </div>
                </div>
            </div>
            <ToastContainer/>
        </>
    );
};

export default translate(Invitation);